<div class="gallery-overlay" (click)="onClose()">
  <button class="gallery-close" (click)="onClose()">&times;</button>

  <button class="gallery-nav gallery-prev" *ngIf="hasMultiple" (click)="$event.stopPropagation(); prev()">&#8249;</button>

  <div class="gallery-content" (click)="$event.stopPropagation()">
    <img [src]="images[currentIndex]" alt="Image {{ currentIndex + 1 }}" />
  </div>

  <button class="gallery-nav gallery-next" *ngIf="hasMultiple" (click)="$event.stopPropagation(); next()">&#8250;</button>

  <div class="gallery-dots" *ngIf="hasMultiple" (click)="$event.stopPropagation()">
    <span *ngFor="let img of images; let i = index"
      class="gallery-dot"
      [class.active]="i === currentIndex"
      (click)="goTo(i)">
    </span>
  </div>
</div>
